export default __webpack_public_path__ + "static/media/cool-earth-charity.cef88446.jpg";